import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Injectable()
export class BrandsService { 
  readonly url = environment.baseUrl + "Proizvodjaci/";
  constructor(private http: HttpClient) {}

  public getBrands() {
    return this.http.get(this.url + "GetAll");
  }

}
